import styled from '@emotion/styled'
import { H3, P1 } from 'src/components/Typography'
import { DESKTOP_BREAKPOINT } from 'src/constants/breakPoints'

const Section = {
  Title: styled(H3)`
    color: #1b2736;
    margin-bottom: 5px;
  `,
  Subtitle: styled(P1)`
    color: #777777;
    margin-bottom: 5px;
  `,
  Row: styled.div`
    display: block;
    ${DESKTOP_BREAKPOINT} {
      display: flex;
      flex-wrap: wrap;
    }
  `,
  Left: styled.div`
    flex-basis: 0px;
    flex-grow: 1;
    flex-shrink: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    min-width: unset;

    ${DESKTOP_BREAKPOINT} {
      min-width: 290px;
    }
  `,
  Right: styled.div`
    flex-basis: 0px;
    flex-grow: 1;
    flex-shrink: 0;
    margin-bottom: 20px;
    min-width: unset;

    ${DESKTOP_BREAKPOINT} {
      min-width: 290px;
    }
  `,
}

export default Section
